import { useQuery } from '@tanstack/react-query';

import { accountRepo } from '@ctct/domain-layer';

import { QueryKeys } from './constants';
import { useQueryMemoized } from '../helpers/useQueryMemoized';

export const usePlanDetail = () => {
  const query = useQuery({
    queryKey: [QueryKeys.PLAN_DETAIL],
    queryFn: accountRepo.getPlanDetail,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });

  return useQueryMemoized(query);
};

export type UsePlanDetail = ReturnType<typeof usePlanDetail>;
